module.exports = __webpack_public_path__ + "static/media/In_Consequence.54604ab1.mp3";